import { BaseRoutes } from './base.routes.constants';

export class ContaRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
